import React, { useCallback, useState } from "react";
import { GridLegacy, IconButton, TableCell, TextField, Tooltip } from "@mui/material";
import TranslationWrapper from "../../components/TranslationWrapper/TranslationWrapper";
import MainNavbar from "../../components/Navbars/MainNavbar";
import GridContainer from "../../components/Grid/GridContainer";
import GridItem from "../../components/Grid/GridItem";
import Button from "../../components/CustomButtons/Button";
import AuthenticationWrapper from "../../auth/AuthenticationWrapper";
import { withStyles } from "tss-react/mui";
import vestigingStyle from "../../assets/jss/material-dashboard-pro-react/views/vestigingStyle";
import { Add, Delete } from "@mui/icons-material";
import CreateNewRoleDialog from "./CreateNewRoleDialog";
import JamezzTableV2, { useReloadState } from "../../components/JamezzTable/V2/JamezzTableV2";
import FormElement from "../../components/JamezzTable/FormElement";
import Person from "@mui/icons-material/Person";
import { Link } from "react-router";
import Edit from "@mui/icons-material/Edit";
import AreYouSureDialog from "../../components/Dialogs/AreYouSureDialog";
import { useDialog } from "../../licensing/utils/DialogProvider";
import { _post } from "../../http";
import useJTFilter from "../../components/JamezzTable/V2/useJTFilter";

const endPoint = "core/roles";

function Roles({ classes }) {
  const [newRoleDialogIsOpen, setNewRoleDialogIsOpen] = useState(false);
  const { reloadState, updateReloadState } = useReloadState();
  const [textField, filters] = useJTFilter("name");

  const [openDialog] = useDialog();
  const renderHeaderCells = useCallback(
    () => [
      { id: "id", label: "#", numeric: true, disablePadding: false, sortable: true },
      {
        id: "name",
        label: <TranslationWrapper tDefault={"Role name"} tKey={"roles.name"} />,
        numeric: false,
        disablePadding: false,
        sortable: true,
      },
    ],
    []
  );

  const renderRowCells = useCallback((row, isEditable) => {
    return (
      <>
        <TableCell align={"right"} style={{ width: 100 }}>
          {row.id}
        </TableCell>
        <TableCell>
          {isEditable ? (
            <FormElement endPoint={"core/roles"} name={"name"} row={row}>
              <TextField size={"small"} variant={"standard"} />
            </FormElement>
          ) : null}
          {!isEditable ? row.name : null}
        </TableCell>
      </>
    );
  }, []);

  const renderSelectionActions = useCallback((selected) => {
    return (
      <Tooltip title={<TranslationWrapper tKey={"Delete"} />}>
        <IconButton
          onClick={() => {
            openDialog({
              children: (
                <AreYouSureDialog
                  content={<TranslationWrapper tKey={"Are you sure you want to delete the selected roles?"} />}
                  onOk={() => {
                    _post("/core/roles/multipledelete", { ids: selected }).then(() => {
                      updateReloadState();
                    });
                  }}
                />
              ),
            });
          }}
          style={{ color: "lightcoral" }}
        >
          <Delete />
        </IconButton>
      </Tooltip>
    );
  }, []);

  const renderRowActions = useCallback((row) => {
    return (
      <TableCell align={"right"}>
        <Link to={`./${row.id}/edit`}>
          <Tooltip
            classes={{ tooltip: classes.tooltip }}
            placement={"bottom"}
            title={<TranslationWrapper tDefault={"Edit"} tKey={"global.jamezzTable.edit"} />}
          >
            <IconButton color={"primary"} simple size={"small"}>
              <Edit />
            </IconButton>
          </Tooltip>
        </Link>
      </TableCell>
    );
  }, []);

  return (
    <div>
      <MainNavbar paginaTitel={<TranslationWrapper tDefault={"Roles"} tKey={"roles.table.title"} />} />
      <GridContainer>
        <GridItem xs={12}>
          <AuthenticationWrapper
            child={
              <Button
                className={classes.marginRight}
                color={"success"}
                onClick={() => {
                  setNewRoleDialogIsOpen(true);
                }}
              >
                <Add className={classes.icons} />{" "}
                <TranslationWrapper tDefault={"Create new role"} tKey={"roles.createNewRole"} />
              </Button>
            }
            permissionKey={"roles.create"}
          />
        </GridItem>
      </GridContainer>
      <GridLegacy container spacing={1}>
        <GridLegacy item xs={12}>
          {textField}
          <JamezzTableV2
            checkboxSelection={true}
            dense={true}
            endPoint={"core/roles"}
            filters={filters}
            headerIcon={<Person />}
            reloadState={reloadState}
            renderCellsForRow={renderRowCells}
            renderHeaderCells={renderHeaderCells}
            renderRowActions={renderRowActions}
            renderSelectionActions={renderSelectionActions}
            tableTitle={<TranslationWrapper tDefault={"Roles"} tKey={"roles.table.title"} />}
            uuid={"Roles-1290uieodwklmkn"}
          />
        </GridLegacy>
      </GridLegacy>
      {newRoleDialogIsOpen ? (
        <CreateNewRoleDialog
          onClose={() => {
            setNewRoleDialogIsOpen(false);
          }}
        />
      ) : null}
    </div>
  );
}

export default withStyles(Roles, vestigingStyle);
